import React, { Component } from 'react'
import { Link } from 'gatsby'
import Card from '../Card'
import moment from 'moment'
import PostCover from '../PostCover'
import config from '../../../data/SiteConfig'
import './ConsiderReading.scss'

class ConsiderReading extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: true,
    }
    this.handleResize = this.handleResize.bind(this)
  }
  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({ mobile: false })
    } else {
      this.setState({ mobile: true })
    }
  }
  render() {
    const { fileEdges, blog } = this.props

    const blogNodeList = fileEdges.filter(fileEdge => {
      if (fileEdge.node === null) return false

      if (fileEdge.node.fields.slug.indexOf(blog) !== -1) return true

      return false
    })

    const postSlug = blogNodeList[0].node.fields.slug
    const postFrontmatter = blogNodeList[0].node.frontmatter
    const { mobile } = this.state
    const expand = mobile
    /* eslint no-undef: "off" */
    const coverHeight = mobile ? 222 : 257

    return (
      <Card width="width-12/12 post-preview expanded consider-reading">
        <div className="grid grid-columns">
          <div className="width-6/12 media-details">
            <h3>Consider Reading</h3>
            {postFrontmatter.layout == 'video' ? (
              <div className="post-layout">
                <i title="Video" className="fa fa-play-circle"></i>
                <span className="post-layout--type">
                  {' '}
                  Video - {postFrontmatter.category}
                </span>
              </div>
            ) : (
              <div className="post-layout">
                <i title="blog" className="fa fa-file-text-o"></i>
                <span className="post-layout--type">
                  {' '}
                  Blog - {postFrontmatter.category}
                </span>
              </div>
            )}
            <Link style={{ textDecoration: 'none' }} to={postSlug}>
              <h4>{postFrontmatter.title}</h4>
            </Link>
            <div>
              <p>
                <i title="Published on" className="fa fa-calendar"></i>
                <span className="post-date">
                  {' '}
                  {moment(postFrontmatter.date).format(config.dateFormat)}
                </span>
              </p>
            </div>
          </div>
          <div className="media width-6/12 post-cover">
            <Link style={{ textDecoration: 'none' }} to={postSlug}>
              <div style={{ height: coverHeight, paddingBottom: '0px' }}>
                <PostCover
                  postNode={postFrontmatter}
                  coverHeight={coverHeight}
                />
              </div>
            </Link>
          </div>
          <div className="consider-reading--decor">
            <div className="red-triangle"> </div>
            <div className="white-triangle"> </div>
          </div>
        </div>
      </Card>
    )
  }
}

export default ConsiderReading
